import { IKeyValuePair } from '../models/common/IKeyValuePair';

export function getQueryStringValue(mapping: Partial<IKeyValuePair>, queryString: string): string | undefined {
	if (mapping.value) {
		return mapping.value;
	}
	let name = mapping.key;
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	const results = regex.exec(queryString);
	return results === null ? undefined : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function getUrlValueFromFormat(mapping: Partial<IKeyValuePair>, urlFormat: string, url: string): string | undefined {
	if (mapping.value) {
		return mapping.value;
	}
	const name = mapping.key;
	const urlPieces = url.split('/');
	const urlFormatPieces = urlFormat.split('/');
	if (urlPieces.length === urlFormatPieces.length) {
		for (let index = 0; index < urlFormatPieces.length; index++) {
			const formatPiece = urlFormatPieces[index];
			const placeholder = `{${name}}`;
			if (formatPiece === placeholder) {
				return urlPieces[index];
			}
		}
	}
	else {
		console.error(`URL does not match provided urlFormat. URL: ${url}, urlFormat: ${urlFormat}`);
	}
	return;
}
